import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { DoCreateSignedUrlQueryResponse, DoCreateSignedUrlQueryParams } from "../../types/DoCreateSignedUrl";

/**
     * @link /api/credit-flow-backend/v1/documents/do_create-signed-url
     */
export async function doCreateSignedUrl (params: DoCreateSignedUrlQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<DoCreateSignedUrlQueryResponse>["data"]> {
    const { data: resData } = await client<DoCreateSignedUrlQueryResponse>({
        method: "get",
        url: `/api/credit-flow-backend/v1/documents/do_create-signed-url`,
        params,
        ...options
    });
    
    return resData;
};